var chunkMapping = {
	"860": [
		20124,
		62797,
		88296,
		93947
	],
	"5228": [
		75228
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	],
	"8186": [
		99406
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		21459
	],
	"7293": [
		"default",
		"./AppLoader",
		21459
	],
	"17418": [
		"default",
		"./appSlice",
		21459
	],
	"20124": [
		"default",
		"./components/NotificationBell",
		21459
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		21459
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		21459
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		21459
	],
	"49394": [
		"default",
		"./store",
		21459
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		21459
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		21459
	],
	"75228": [
		"default",
		"./utils/constants",
		21459
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		21459
	],
	"85646": [
		"default",
		"./headerSlice",
		21459
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		21459
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		21459
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		21459
	],
	"99406": [
		"default",
		"./providers/FlagsmithProvider",
		21459
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"20124": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	],
	"99406": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 21459
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}